import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  'zh-CN': require('./zh-CN.json'),
  'en': require('./en.json')
}

const i18n = new VueI18n({
  locale: 'zh-CN', // 默认语言
  fallbackLocale: 'zh-CN',
  messages
})

export default i18n